var exports = {
  "j": "x31de4314--b30b25--cont",
};

module.exports = exports;
